import { Pipe, PipeTransform } from '@angular/core';
import { UsuarioService } from '../shared/services/usuario-service';

@Pipe({
    name: 'nomeUsuario',
    standalone: false
})
export class NomeUsuarioPipe implements PipeTransform {
    constructor(private usuarioService: UsuarioService) {
    }

    transform(userId?: any): Promise<string> {
    	if (!userId) return userId;
      
        return this.usuarioService.getNomeUsuario(userId).toPromise().then((resp) => {
            return resp ? resp : userId;
        });
    }
}
